var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-message-base"},[_c('CommonHeader',{staticClass:"header",attrs:{"pinned":true}},[_vm._v("\n    "+_vm._s(_vm.$t('message.name'))+"\n    ")]),_c('main',[_c('RouterView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }